import { CodetableMetadataWire } from "app/area/import-mappings/types";
import { CodetableMetadata } from "app/area/import-mappings/types-store";

export const mapMetadataToStore = (metadataWire: CodetableMetadataWire): CodetableMetadata => ({
  ...(!!metadataWire.category && {
    codetableCategory: metadataWire.category
  }),
  ...(!!metadataWire.code && {
    code: metadataWire.code
  }),
  hierarchy: metadataWire.hierarchy,
  label: metadataWire.label
});
